import axiosInstance from "../axios_instance";

export async function getRefereeData(userId, filters = {}) {
  try {
    const params = new URLSearchParams();

    if (filters.name) {
      params.append('name', filters.name.trim());
    }

    if (filters.type) {
      params.append('type', filters.type);
    }

    if (filters.activityStatus) {
      params.append('activityStatus', filters.activityStatus);
    }

    if (filters.page) {
      params.append('page', filters.page);
    }

    if (filters.limit) {
      params.append('limit', filters.limit);
    }

    const queryString = params.toString();
    const url = `referalManagement/referee/${userId}${queryString ? `?${queryString}` : ''}`;

    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getRefereeStats(userId) {
  try {
    const url = `referalManagement/clientRefererStats/${userId}`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function getRefereeServiceHistory(userId) {
  try {
    const url = `referalManagement/refereeServiceHistory/${userId}`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function getReferersData(obj = {}) {
  try {
    const params = new URLSearchParams();

    if (obj.refererName) {
      params.append('refererName', obj.refererName.trim());
    }

    if (obj.refererType) {
      params.append('refererType', obj.refererType);
    }

    if (obj.page) {
      params.append('page', obj.page);
    }

    if (obj.limit) {
      params.append('limit', obj.limit);
    }

    const url = `referalManagement/refererData${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getReferralsStats(userId) {
  try {
    const url = `referalManagement/referalManagementStats/${userId}`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function requestRefererWithdrawl(body) {
  try {
    return await axiosInstance.post(`withdrawals/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateRefererWithdrawlAcceptance(body) {
  try {
    return await axiosInstance.put(`withdrawals/acceptanceStatus`, body);
  } catch (error) {
    return error;
  }
}

export async function getRefererWithdrawlHistory(userId) {
  try {
    const url = `withdrawals/${userId}`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function getRefererWithdrawlRequests(body) {
  try {
    const url = `referalManagement/referersWithdrawlRequests`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function getRefererWithdrawlRequestsStats(body) {
  try {
    const url = `withdrawals/withdrawlsStats`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}
